<div class="video-player-container">
    <video autoplay width="100%" height="100%" [src]="videoUrl" controls controlsList="nodownload" disablePictureInPicture>
    </video>
</div>